'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFreshStateFromFund = undefined;

var _spinner_utility = require('../../../packages/common-utilities/src/spinner_utility.js');

var _spinner_utility2 = _interopRequireDefault(_spinner_utility);

var _ramda = require('ramda');

var _collection_utility = require('common-utilities/src/collection_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FundsState = {
  createFreshStateFromFund: function createFreshStateFromFund(cusip, country, productDetail, fundPerformanceData, owcsContent, isResponseInArrayFormat) {
    var fundData = void 0;
    var fundManagerImages = void 0;
    var messageStatus = '';
    var redirectToFundDocuments = false;
    if (isResponseInArrayFormat) {
      fundData = productDetail[0].fundData;
      fundManagerImages = productDetail[0].fundManagerImages;
    } else {
      fundData = productDetail.fundData;
      fundManagerImages = null;
    }
    var freshState = void 0;
    if (!(0, _ramda.isNil)(fundData) && fundData.isLiquidatedOrMergedAway) {
      messageStatus = 'pdp-fund-documents-redirect';
      redirectToFundDocuments = true;
      freshState = { messageStatus: messageStatus, redirectToFundDocuments: redirectToFundDocuments };
    } else if (!(0, _ramda.isNil)(fundData) && !fundData.isCriticalDataMissing) {
      var fund = _collection_utility.CollectionUtility.merge({}, fundData, { shareclassList: fundData.shareClass }, { fundManagerImages: fundManagerImages }, { fundDocuments: owcsContent.documentsData }, { fundContent: owcsContent.fundContent });

      freshState = {
        messageStatus: messageStatus,
        redirectToFundDocuments: redirectToFundDocuments,
        country: country,
        cusip: cusip,
        fund: fund,
        currentShareclass: {
          category: fundData.shareClass.fundShareclassCategory
        },
        performance: fundPerformanceData
      };
    } else {
      _spinner_utility2.default.stopSpinner();
      messageStatus = 'pdp-cusip-no-data';
      freshState = { messageStatus: messageStatus, redirectToFundDocuments: redirectToFundDocuments };
    }
    return freshState;
  }
};

exports.default = FundsState;
var createFreshStateFromFund = FundsState.createFreshStateFromFund;
exports.createFreshStateFromFund = createFreshStateFromFund;